<template>
  <div>
    <div v-if="isForcedRedirect || userInfo.redirect_to_zt == 1" class="wrapper">
      <el-empty description="暂无查询权限" />
      <div class="btn-box" v-if="isShowBtn">
        <el-button type="primary" size="small" @click="jump">跳转v2</el-button>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import { goNewSys, getLocalUserInfo } from '@/util/index'
export default {
  props: {
    // 跳转到v2的参数，
    jumpParams: {
      type: Object,
      default: () => ({})
    },
    isShowBtn: {
      type: Boolean,
      default: true
    },
    // 是否强制跳转，如果true就不需要判断 redirect_to_zt 是否为1
    isForcedRedirect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userInfo: {}
    }
  },
  mounted() {
    //  获取本地的用户信息
    this.userInfo = getLocalUserInfo();
    if (this.isForcedRedirect || this.userInfo.redirect_to_zt == 1) {
      this.jump()
    }
  },
  methods: {
    jump() {
      goNewSys(this.jumpParams)
    }
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  background: #FFF;
  height: 85vh;

  .btn-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>